import React from 'react';
import { Dialog, DialogActions, DialogContent, Typography, Button } from 'nxg-ui-wrapper';
import { DeleteMachineLogConfirmationDialogStyle as styles } from './DeleteMachineLogConfirmationDialogStyle';
import { useAuthenticated } from 'src/hooks/context';
import { TypeCommon, TextCommon, TestCommon, BaseCommon } from 'src/common';
import { DEFAULT_DELETE_DIALOG_WIDTH, DEFAULT_BORDER_RADIUS } from 'src/common/machine.common';
import { TypeContext } from 'src/store';
import { IDeleteMachineLogItem } from 'src/types/MachineManagement';
import { GlobalPreservedSpace } from 'src/components';
import { EButtonVariant } from 'src/types';

interface IDeleteConfirmationDialogProps {
    onDelete: (deleteMachineLogItem: IDeleteMachineLogItem) => void;
    params: IDeleteMachineLogItem;
}

const DeleteConfirmationDialog = (props: IDeleteConfirmationDialogProps): JSX.Element => {
    const [appState, dispatch]: TypeContext = useAuthenticated();
    const { onDelete, params } = props;
    const setCloseDialog = (): void => dispatch(TypeCommon.setIsOpenDeleteMachineLogConfirmationDialog(false));
    const getDeleteModeText = (): string => {
        switch (params.mode) {
            case BaseCommon.DELETE_MODE_All:
                return TextCommon.DELETE_MODE_ALL;
            case BaseCommon.DELETE_MODE_AFTER:
                return TextCommon.DELETE_MODE_AFTER;
            case BaseCommon.DELETE_MODE_BEFORE:
                return TextCommon.DELETE_MODE_BEFORE;
            default:
                return BaseCommon.EMPTY_STRING;
        }
    };
    return (
        <Dialog
            PaperProps={{ style: { width: DEFAULT_DELETE_DIALOG_WIDTH, borderRadius: DEFAULT_BORDER_RADIUS } }}
            BackdropProps={{ style: styles.backdrop }}
            fullWidth={true}
            open={true}
        >
            <DialogContent sx={styles.dialogContent} data-testid={TestCommon.DELETE_MACHINE_LOG_CONFIRMATION_DIALOG_DATA_TEST_ID}>
                <Typography component="p" fontWeight={600}>
                    {TextCommon.DELETE_MACHINE_LOG_CONFIRMATION_QUESTION_TEXT}
                </Typography>
                <Typography variant="h5" fontWeight={600}>
                    <GlobalPreservedSpace>{params.id}</GlobalPreservedSpace>
                </Typography>
                <Typography component="p">
                    <span>{TextCommon.LOG_PERIOD}</span>
                    <span style={styles.boldText}>{getDeleteModeText()} </span>
                    <span style={styles.boldText}>{params.dateTime} </span>
                </Typography>
            </DialogContent>
            <DialogActions sx={styles.dialogAction} data-testid={TestCommon.DELETE_MACHINE_LOG_CONFIRMATION_DIALOG_ACTION_DATA_TEST_ID}>
                <Button variant={EButtonVariant.OUTLINED} sx={styles.cancelButton} onClick={setCloseDialog} name="cancel">
                    {TextCommon.CANCEL}
                </Button>
                <Button variant={EButtonVariant.CONTAINED} sx={styles.deleteButton} onClick={(): void => onDelete(params)} name="yes">
                    {TextCommon.YES_DELETE}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
